module.exports = __webpack_public_path__ + "static/media/22.8e0d7f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/22.png
// module id = 804
// module chunks = 0